import Vue from 'vue'

Vue.filter('codeAsString', function (code) {
  if (!code) return ""
  return code.text
})

export default {}
